import { Agent, PaymentMethodType } from '@nemuru-eng/js-api-client';

export const hasSelectedAgentOnlyAutoPaymentMethods = (selectedAgent: Agent | undefined) => {
  if (!selectedAgent) return undefined;
  const allowedPaymentMethods = selectedAgent?.allowedPaymentMethodTypes;
  if (!allowedPaymentMethods || allowedPaymentMethods.length === 0) return false;

  const autoPaymentMethodTypes = [PaymentMethodType.AUTO_LOAN, PaymentMethodType.B2B_LOAN];
  return (
    allowedPaymentMethods.length <= 2 && allowedPaymentMethods.every((type) => autoPaymentMethodTypes.includes(type))
  );
};
